/**
 * The selected row's tick.
 *
 * BACK, and the reversal is the headline of the 2026-09-15 `List-Item` rework (node 82:7424).
 * Design feedback on HNS-362 had removed it, leaving the selected row distinguished by colour
 * alone — recorded at the time as a trade, with the note that a colour-blind user would be relying
 * on `aria-selected` and nothing else. The reworked cells draw it on every
 * `Type=Single Select, isSelected=True` cell and draw no colour step at all, so this is now the
 * whole of the selected state and the announced state has a visual partner again.
 *
 * ── Why this is its own module ─────────────────────────────────────────────────────────────────
 *
 * So the state matrix in `Select.stories` can render the real glyph instead of a copy of it. That
 * matrix poses states Base UI owns — `data-highlighted`, `data-selected` — by writing the
 * attributes onto rows built from the recipe, which means it cannot go through `Select` to get the
 * tick. A second transcription of the same vector living in a story is exactly the drift this
 * layer keeps catching elsewhere.
 *
 * It is deliberately NOT in `Select/index.ts`, so it stays out of the `components` barrel. The
 * story imports it by path. Nothing outside this folder should draw a select's tick.
 *
 * ── Why the vector is inline, and a fill ───────────────────────────────────────────────────────
 *
 * Inline rather than `CheckIcon` from `icons`, following `Checkbox`, which transcribes its own tick
 * for the same reason: the library glyph is the MATERIAL check under the legacy flag and Phosphor's
 * under the refresh, so what renders would depend on a flag this popup has no business reading —
 * and the cell draws one specific tick.
 *
 * The path is Figma's own flattened vector out of the cell's `Check (Stroke)` node, in its own 16px
 * viewBox, exported rather than retyped. A FILL rather than a stroke, unlike the caret and the
 * checkbox's tick, because the cell's vector is a flattened outline and there is no stroke width to
 * transcribe.
 *
 * Hence `fill="currentColor"` as an ATTRIBUTE, and no `fill="none"` on the root. A CSS rule beats a
 * presentational attribute, which is the DS trap that renders a glyph laid out, sized, accessible
 * and completely blank — the colour comes from `selectItemCheckRecipe`'s `text-*`, which sets
 * `currentColor` rather than `fill`.
 *
 * `aria-hidden`, because Base UI already puts `aria-selected` on the row. A second announced
 * "selected" is how a listbox starts reading twice.
 */
export const SelectCheckMark = () => (
  <svg aria-hidden="true" focusable="false" viewBox="0 0 16 16">
    <path
      d="M11.9221 3.58177C12.3743 3.09735 13.1343 3.07108 13.6188 3.52319C14.1032 3.97532 14.1295 4.73541 13.6774 5.21986L6.9575 12.419C6.7307 12.6618 6.41331 12.7997 6.08104 12.7998C5.74855 12.7998 5.43033 12.662 5.20342 12.419L2.3233 9.3338C1.87117 8.84938 1.89748 8.08929 2.38189 7.63714C2.86633 7.18499 3.62641 7.21128 4.07855 7.69572L6.07987 9.83999L11.9221 3.58177Z"
      fill="currentColor"
    />
  </svg>
);
